import $ from 'jquery';
import slick from 'slick-carousel';

export default {
    init() {

        var container = document.querySelector('.shopAdvertisement');

        if( container ) {

            function shopAdvertisementCarousel( container ) {

                var carousel = container.querySelector('.content__prods');
                var buttonNext = container.querySelector('.bottom__button--next');
                var buttonPrev = container.querySelector('.bottom__button--prev');

                $(carousel).on('breakpoint', function(event, slick, breakpoint) {

                    $(container).find('.basic__title').removeClass('fit-content');
                    setTimeout(function(){ $(container).find(' .basic__title').addClass('fit-content'); }, 500);

                });

                $(carousel).on('init', function(slick) {

                    $(container).find('.basic__title').removeClass('fit-content');
                    setTimeout(function(){ $(container).find('.basic__title').addClass('fit-content'); }, 500);

                });

                $(carousel).slick({
                    arrows: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 300,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    rows: 0,
                    responsive : [
                        {
                            breakpoint: 1201,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 961,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 349,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ]
                });
                
                buttonNext.addEventListener('click', function() {
                    $(carousel).slick('slickNext');
                    $(carousel).slick('slickPause');
                });
                buttonPrev.addEventListener('click', function() {
                    $(carousel).slick('slickPrev');
                    $(carousel).slick('slickPause');
                });
                $(carousel).on('swipe', function(event, slick, direction) {
                    $(carousel).slick('slickPause'); 
                });
                container.querySelector('.shop__content').classList.remove('hide');
            }
            shopAdvertisementCarousel( container );
        }
    },
    finalize() {
    }
}